export default "__VITE_ASSET__f250b83c__"